import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'underscore'
import $ from 'jquery'
import {
  fetchResumesData,
  downloadOutputResume,
  reportConversionError,
  toggleCandidateDetailsModal,
  fetchTemplateConfigurations,
  callResumeDuplicate,
  fetchTemplatesData,
} from '../../actions/actions'
import CustomDropdown from '../components/CustomDropdown'
import Loader from '../components/Loader'
import { downloadFile } from '../../services/helpers'
import { customSelectStyles } from '../../config/styles'
import '../../styles/_resume_listing_container.scss'
import CandidateDetailsVerification from './CandidateDetailsVerification'
import { Modal, ModalBody } from "../modals/Modal"

const baseUrl = 'https://vmockvideofiles.s3.amazonaws.com/assets/images/'

const sortingOptions = [
  {
    value: 1,
    label: 'Upload Date (Ascending)',
    key: 'asc',
  },
  {
    value: 2,
    label: 'Upload Date (Descending)',
    key: 'desc',
  },
]

const failedReasonHeadings = {
  pdf_failed: 'Resume Output Fail',
  conversion_failed: 'Resume Conversion Fail',
  parser_failed: 'Resume Processing Fail',
}
const failedReasons = {
  TOO_MANY_PAGES: 'Make sure your uploaded resume is within 10 pages.',
  INVALID_LANGUAGE:
    'Make sure the uploaded resume is in english as we do not support any other language yet.',
  TOO_FEW_DIVS: 'Please include more content in your resume and re-upload.',
  TOO_FEW_SECTIONS:
    'Please include more sections in your resume and re-upload.',
  PASSWORD_PROTECTED:
    'Please remove password protection from PDF and re-upload.',
  IS_IMAGE:
    'Oops! You are trying to upload resume converted from Images to PDF.',
  MALFORMED_PDF: 'Oops! You are trying to upload a corrupted PDF.',
  UNSUPPORTED_FONT:
    "We recommend changing the Font Type to any of the 'Regular' formats available in Microsoft Word. You can also use any of the following: Calibri, Nimbus roman, Times new roman, Cambria, Garamond, Arial, Tahoma, Verdana, Helvetica.",
  PDF_IS_NOT_RESUME: 'Make sure you have uploaded a valid resume.',
  pdf_failed: 'We are not able to generate output for your uploaded resume.',
  conversion_failed:
    'We are not able to convert your uploaded resume to required template.',
}

const ResumeListing = () => {
  const allResumeData = useSelector((state) => state.resumesData.data)
  const totalPageCount = useSelector(
    (state) => state.resumesData.totalPageCount
  )
  const resumesDataFetching = useSelector((state) => state.resumesData.fetching)
  const authToken = useSelector((state) => state.authToken)
  const activeCandidateId = useSelector((state) => state.activeCandidateId)
  const candidateDetailsModalOpen = useSelector((state) => state.candidateDetails.isOpen)
  const templatesData = useSelector((state) => state.templatesData.data)

  const [resumeData, setResumeData] = useState(allResumeData)
  const [sortKey, setSortKey] = useState(null)
  const [currentPage, setCurrentPage] = useState(1)
  const [searchQuery, setSearchQuery] = useState('')
  const [failurePopupData, setFailurePopupData] = useState({
    open: false,
    resume_id: null,
  })
  const [dropdownIndex, setDropdownIndex] = useState(-1)
  const [showDuplicateWarningModal, setshowDuplicateWarningModal] = useState(false)
  const [duplicateModalIndex, setDuplicateModalIndex] = useState({ resumeId: -1, builderId: -1 })
  const templateConfigurations = useSelector((state) => state.templatesData.templateConfigurations || {})
  const ref = useRef(null)
  const dispatch = useDispatch()
  const fetchFilterResultsTimeoutRef = useRef(null)
  let columnStylesData = activeCandidateId && false
    ? {
        columns: [
          'resume-name',
          'uploaded-date',
          'processing-status',
          'actions',
        ],
        names: ['File Name', 'Upload Date', 'Processing Status', 'Download'],
        widths: [35, 25, 20, 20],
      }
    : {
        columns: [
          'candidate-name',
          'resume-name',
          'uploaded-date',
          'processing-status',
          'actions',
        ],
        names: [
          'Candidate Name',
          'File Name',
          'Upload Date',
          'Processing Status',
          'Download',
        ],
        widths: [30, 25, 15, 15, 15],
      }

  useEffect(() => {
    if (allResumeData) {
      setResumeData(allResumeData)
      setTimeout(() => {
        $('.items-container').scrollTop(0)
      }, 400);
    }
  }, [allResumeData])

  useEffect(() => {
    if (authToken) {
      dispatch(fetchTemplatesData())
    }
  }, [authToken])

  useEffect(() => {
    dispatch(fetchTemplateConfigurations())
  }, [])

  useEffect(() => {
    clearTimeout(fetchFilterResultsTimeoutRef.current)
    fetchFilterResultsTimeoutRef.current = setTimeout(() => {
      dispatch(fetchResumesData(1, searchQuery, sortKey))
    }, 2000)
  }, [searchQuery])

  useEffect(() => {
    if (sortKey) {
      dispatch(fetchResumesData(currentPage, searchQuery, sortKey))
    }
  }, [sortKey])

  useEffect(() => {
    const element = ref.current
    element.addEventListener('click', handleClickOutside)
    return () => {
      element.removeEventListener('click', handleClickOutside)
    }
  }, [failurePopupData, dropdownIndex])

  useEffect(() => {
    clearTimeout(fetchFilterResultsTimeoutRef.current)
    fetchFilterResultsTimeoutRef.current = setTimeout(() => {
      dispatch(fetchResumesData(currentPage, searchQuery))
    }, 10)
  }, [currentPage])

  const handleSearchQueryChange = (event) => {
    let value = event.target.value
    if (value && value.trim()) {
      setSearchQuery(value)
    } else {
      setSearchQuery(null)
    }
  }

  const handleSortKeyChange = (sortOption, id = null, type = null) => {
    setSortKey(sortOption.key)
  }

  const handleClickOutside = (event) => {
    let target = $(event.target)
    if (
      failurePopupData.open &&
      target.closest('.icon-exclamation-outline').length === 0 &&
      target.closest('.failure-popup').length === 0
    ) {
      setFailurePopupData({ open: false, resume_id: null })
    }
    if (
      dropdownIndex !== -1 &&
      target.closest('.download-dropdown').length === 0
    ) {
      setDropdownIndex(-1)
    }
  }

  const renderActionButtons = (itemStatus, resume, idx) => {
    let builderId = resume.builder_template_id,
      resumeId = resume.id
    let templateConfiguration = templateConfigurations[builderId] || {}
    let outputsAllowed = templateConfiguration.output_document_type
        ? templateConfiguration.output_document_type.split(",")
        : [],
      actions =
        templateConfiguration &&
        templateConfiguration.actions &&
        templateConfiguration.actions[itemStatus]
          ? templateConfiguration.actions[itemStatus]
          : [],
      verificationRequired =
        templateConfiguration?.is_verification_required === "true" || false
    if (_.isEmpty(actions?.action)) return null
    return (
      <div>
        <div className="action-btn-container">
          {_.map(actions.action, (action) => {
            let disabled = !action.is_active,
              ariaLabel = "",
              verifyDetailsClass = ""
            if (action.name === "Verify Details") {
              if (!candidateDetailsModalOpen) verifyDetailsClass = "tooltipped tooltipped-s"
              disabled = !action.is_active || !verificationRequired
              if (disabled) {
                ariaLabel = "Verify Details once resume processing is done."
                verifyDetailsClass += " light-bg"
              } else {
                ariaLabel =
                  "Verify details to download the user's overview profile."
                verifyDetailsClass += " red-bg"
              }
            }
            let icon =
              action.name === "Download" ? (
                <span className="icon-download-1" />
              ) : action.name === "Edit" ? (
                <span className="icon-edit-1" />
              ) : null
            return (
              <div
                className={`action-btn ${disabled ? "disabled-button" : ""} ${verifyDetailsClass}`}
                aria-label={ariaLabel}
                tabIndex={disabled ? -1 : 0}
                onClick={() => {
                  if (itemStatus === "processed" && !disabled) {
                    if (action.name === "Download") setDropdownIndex(idx)
                    else if (action.name === "Edit") {
                      setshowDuplicateWarningModal(true)
                      setDuplicateModalIndex({ resumeId, builderId })
                    }
                  } else if (itemStatus === "pending_verification" && !disabled) {
                    dispatch(
                      toggleCandidateDetailsModal({ isOpen: true, resumeId, builderId })
                    )
                  } else if (itemStatus === "failed" && !disabled) {
                    dispatch(reportConversionError(resumeId))
                  }
                }}
              >
                {icon}
                {action.name}
              </div>
            )
          })}
        </div>
        {dropdownIndex === idx && !_.isEmpty(outputsAllowed) ? (
          <div className={`download-dropdown ${idx === 9 ? "last" : ""}`}>
            {_.map(outputsAllowed, (type) => {
              return (
                <span
                  className="download-item"
                  onClick={() => (
                    dispatch(downloadOutputResume(resume.id, type)),
                    setDropdownIndex(-1)
                  )}
                >
                  download as <span>{type}</span>
                </span>
              )
            })}
          </div>
        ) : null}
      </div>
    )
  }

  const closeDuplicateWarningModal = () => {
    setshowDuplicateWarningModal(false)
    setDuplicateModalIndex({ resumeId: -1, builderId: -1 })
  }

  const handleDuplicate = () => {
    const { resumeId, builderId } = duplicateModalIndex
    dispatch(callResumeDuplicate(resumeId, builderId))
    closeDuplicateWarningModal()
  }

  const getTemplateName = (id) => {
    let templateName = ''
    if (_.isEmpty(templatesData)) return templateName
    _.map(templatesData, template => {
      if (template.id === id) templateName = template.name
    })
    return templateName
  }

  const getStatusText = (itemStatus, text, resume) => {
    let builderId = resume.builder_template_id
    let templateConfiguration = templateConfigurations[builderId] || {}
    return templateConfiguration &&
      templateConfiguration.actions &&
      templateConfiguration.actions[itemStatus]
      ? templateConfiguration.actions[itemStatus].display
      : text
  }

  const getItemRow = (resume, idx) => {
    let itemStatus =
      resume.request_state &&
      ["FAILED", "PROCESSED", "IN_CONVERSION", "PENDING_VERIFICATION"].includes(
        resume.request_state
      )
        ? resume.request_state.toLowerCase()
        : "in_parsing"
    let templateName = getTemplateName(resume.builder_template_id)
    let rowHtml = []
    columnStylesData['columns'].forEach((column, index) => {
      let widths = columnStylesData['widths'],
        className = `list-cell list-cell-${column} w-${widths[index]} ${
          index % 2 ? 'double-bordered' : ''
        } ${index === 0 ? 'tl' : 'tc'} ${
          column === 'resume-name' && index === 1
            ? 'list-cell-resume-name-secondary'
            : ''
        } ${
          index === columnStylesData['columns'].length - 1
            ? 'extreme-right'
            : ''
        }`,
        cellHtml = null
      if (column === 'resume-name') {
        cellHtml = resume.filename
      } else if (column === 'uploaded-date') {
        let utaDateStr = new Date(resume.initiated_at + 'Z')
        const localYear = utaDateStr.getFullYear()
        const localMonth = utaDateStr.getMonth() + 1
        const localDay = utaDateStr.getDate()
        const localHours = utaDateStr.getHours()
        const localMinutes = utaDateStr.getMinutes()
        const localSeconds = utaDateStr.getSeconds()
        cellHtml = `${localYear}-${localMonth
          .toString()
          .padStart(2, '0')}-${localDay
          .toString()
          .padStart(2, '0')} ${localHours
          .toString()
          .padStart(2, '0')}:${localMinutes
          .toString()
          .padStart(2, '0')}:${localSeconds.toString().padStart(2, '0')}`
      } else if (column === 'processing-status') {
        let failureStatusText = ''
        if (resume.error_reason) {
          failureStatusText = failedReasons[resume.error_reason] || 'The has been an issue converting this resume.'
        }
        let text =  itemStatus === "failed"
          ? "Failed"
          : ["processed", "pending_verification"].includes(itemStatus)
          ? "Done"
          : "In-Progress"
        let statusText = getStatusText(itemStatus, text, resume)
        cellHtml = (
          <div className="d-flex d-flex-center">
            <span className={`dot-indicator dot-indicator-${text.toLowerCase()}`} />
            {statusText}
            {itemStatus === 'failed' ? (
              <span
                className="icon-exclamation-outline"
                onClick={() => {
                  setFailurePopupData({
                    open: !failurePopupData.open,
                    resume_id: !failurePopupData.open ? resume.id : null,
                  })
                }}
              />
            ) : null}
            {failurePopupData.open &&
            failurePopupData.resume_id === resume.id ? (
              <div
                className={`failure-popup failure-popup-${
                  idx < 1 ? 'bottom' : 'top'
                }`}
              >
                <div className="popup-heading">
                  {failedReasonHeadings[resume.status] || 'Resume processing failed'}
                </div>
                <div className="static-text">
                  There has been some issue while processing this resume.
                </div>
                <div className="failure-reason">
                  {failureStatusText}
                </div>
              </div>
            ) : null}
          </div>
        )
      } else if (column === 'actions') {
        cellHtml = (
            renderActionButtons(itemStatus, resume, idx)
        )
      } else if (column === 'candidate-name') {
        cellHtml = (
          <div className="d-flex d-flex-vertical d-flex-start">
            <div className="candidate-name">
              {resume.firstName} {resume.lastName}
            </div>
            {resume.bullhorn && resume.bullhorn.candidate_id ? ( <div className='candiate-id-container'>
            <div className="candidate-id">
                ID: {resume.bullhorn.candidate_id}
              </div>
              <span class="separator-dot"></span>
            <div className='candidate-template'>{templateName}</div>
            </div>) : null}
          </div>
        )
      }
      rowHtml.push(<div className={className}>{cellHtml}</div>)
    })
    return (
      <div className={`candidate-list-item ${idx === 0 ? 'mt-0' : ''}`}>
        {rowHtml}
      </div>
    )
  }

  return (
    <>
      <div ref={ref} className="resume-listing-container">
        <div className="header-actions-row">
          <div className="heading" role="heading" aria-level="1">
            Resumes converted using VMock
          </div>
          <div
            className={`header-actions-toolbar ${
              resumesDataFetching ? 'overlay-no-actions' : ''
            }`}
          >
            <button
              className="refresh-button"
              onClick={() => {
                dispatch(fetchResumesData(currentPage, searchQuery))
              }}
            >
              Refresh
            </button>
            <div className="divider-line"></div>
            <div className="dropbox-search-container">
              <span className="icon-cmc-search"></span>
              <input
                type="text"
                className="dropbox-search"
                placeholder="Search by filename"
                value={searchQuery}
                onChange={handleSearchQueryChange}
              />
              {false && <span className="icon-cross" onClick={() => {}}></span>}
            </div>
            <div className="dropbox-sort">
              <CustomDropdown
                options={sortingOptions}
                selectedOption={sortingOptions.find(
                  (option) => option.key === sortKey
                )}
                placeholder="Sort By"
                handleChange={handleSortKeyChange}
                customStyles={customSelectStyles}
                showDefaultIndicator={true}
                isSearchable={false}
              />
            </div>
            <div className="dropbox-pagination">
              <span
                className={`icon-caret-left ${
                  Number(currentPage) === 1 || resumesDataFetching ? 'disabled' : ''
                }`}
                onClick={() => {
                  if (Number(currentPage) > 1 && !resumesDataFetching) {
                    setCurrentPage(Number(currentPage) - 1)
                  }
                }}
              ></span>
              <input
                className="page-index"
                type="number"
                value={currentPage}
                min={1}
                max={totalPageCount || 1}
                onChange={(e) => {
                  let value = e.target.value
                  if (Number(value) >= 1 && Number(value) <= totalPageCount) {
                    setCurrentPage(Number(value))
                  }
                }}
              />
              of
              <div className="total-pages">{totalPageCount}</div>
              <span
                className={`icon-caret-right ${
                  Number(currentPage) >= totalPageCount || resumesDataFetching ? 'disabled' : ''
                }`}
                onClick={() => {
                  if (Number(currentPage) < totalPageCount && !resumesDataFetching) {
                    setCurrentPage(Number(currentPage) + 1)
                  }
                }}
              ></span>
            </div>
          </div>
        </div>
        <div className="listing-table-headers">
          {_.map(columnStylesData['names'], (name, index) => {
            let widths = columnStylesData['widths']
            return (
              <div
                className={`header-cell w-${widths[index]} ${
                  index === 0 ? 'tl' : 'tc'
                }`}
              >
                {name}
              </div>
            )
          })}
        </div>
        {resumesDataFetching ? (
          <Loader className={"align-top"}/>
        ) : !_.isEmpty(resumeData) ? (
          <div className="items-container no-scrollbar">
            {_.map(resumeData, (resume, index) => {
              return getItemRow(resume, index)
            })}
          </div>
        ) : (
          <div className="no-data-ui">
            <img src={`${baseUrl}no_conversions.svg`} />
            No resume has been processed!
          </div>
        )}
      {candidateDetailsModalOpen && <CandidateDetailsVerification isOpen={true} />}
      </div>
      {
      showDuplicateWarningModal && duplicateModalIndex.resumeId !== -1 ? (
        <Modal className="duplicate-warning-modal" isOpen={true}>
          <ModalBody>
            <div className="duplicate-warning-container">
              <img src="dist/images/warning-modal-icon.svg"
                  alt="warning modal icon"/>
              <div className="heading">
                Each edit is considered as a separate request
              </div>
              <div className="description">
                Proceed to edit candidate details or cancel
              </div>
              <div className="btn-container">
                <button
                  className="cancel-btn"
                  onClick={() => closeDuplicateWarningModal()}
                >
                  Cancel
                </button>
                <button className="proceed-btn" onClick={() => handleDuplicate()}>Proceed</button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      ) : null
    }
    </>
  )
}

export default ResumeListing
